module.exports = __webpack_public_path__ + "media/1_1-32.72b64bc1.mp3";